<template>
  <Drawer
    title="奖品配置"
    :value="value"
    @input="(value) => $emit('input', value)"
    width="520"
    :mask-closable="false"
    :styles="styles"
  >
    <Collapse v-model="collapseValue">
      <Panel
        :name="ind + 1 + ''"
        v-for="(item, ind) in rewardPoolList"
        :key="ind"
      >
        奖励配置 {{ ind + 1 }}
        <template #content>
          <AwardConfig
            v-model="rewardPoolList[ind]"
            :rs-list="rsList"
            :show="value"
            :docId="docId"
          ></AwardConfig>
        </template>
      </Panel>
    </Collapse>
    <div class="drawer-footer">
      <Button style="margin-right: 8px" @click="$emit('input', false)"
        >取消</Button
      >
      <Button type="primary" @click="$emit('save', rewardPoolList)"
        >确定</Button
      >
    </div>
  </Drawer>
</template>

<script>
import AwardConfig from './AwardConfig.vue'
// import { addCarnivalPrizeReq, updateCarnivalPrizeReq } from '@/api/carnivalApi.js'
export default {
  components: {
    AwardConfig,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    config: {
      type: [Array, null],
      default: null,
    },
    docId: {
      type: Number,
      default: 0,
    },
    rsList: {
      type: Array,
      default: () => {
        return []
      },
    },
  },
  data() {
    return {
      collapseValue: null,
      styles: {
        height: 'calc(100% - 55px)',
        overflow: 'auto',
        paddingBottom: '53px',
        position: 'static',
      },
      data: {
        rewardId: 0,
        price: 0,
        showPrice: 0,
        rewardLevel: 1,
        mark: 0,
        rate: '',
        luckyCount: 0,
        notice: 0,
        orderId: 0,
        rewardType: 1,
        expire: 0,
        valid: 1,
        preUrl: '',
        rewardName: '',
        rewardIcon: '',
        rewardDetailList: [],
      },
      rewardPoolList: [],
      isEdit: false,
    }
  },
  methods: {
    async submitAddConfig() {
      // let res = null;
      // if (this.isEdit) {
      //   res = await updateCarnivalPrizeReq(this, { docId: this.docId, prizeConfig: this.data })
      // } else {
      //   res = await addCarnivalPrizeReq(this, { docId: this.docId, prizeConfig: { ...this.data, parentId: this.parentId } })
      // }
      // if (res.code === 0) {
      //   this.$Message.success('操作成功')
      //   this.$emit('input', false)
      //   this.$emit('refresh')
      // }
    },
  },
  watch: {
    value(newVal) {
      console.log('执行赋值操作', this.config)
      if (newVal) {
        if (!this.config || this.config.length === 0) {
          console.log('滞空')
          this.rewardPoolList = new Array(
            4 + (this.docId > 3 ? 1 : this.docId) * 4
          )
            .fill(null)
            .map((item) => new Object(this.data))
        } else {
          this.rewardPoolList = JSON.parse(JSON.stringify(this.config))
          if (this.rewardPoolList.length < 4 + (this.docId > 3 ? 1 : this.docId) * 4) {
            let arr = new Array(4 + (this.docId > 3 ? 1 : this.docId) * 4 - this.rewardPoolList.length)
              .fill(null)
              .map((item) => new Object(this.data))
            this.rewardPoolList = this.rewardPoolList.concat(arr)
          }
        }
      }
      this.$forceUpdate()
    },
    docId: {
      immediate: true,
      handler(val) {
        console.log('执行赋值操作2')
        console.log(this.config.length)
        if (!this.config || this.config.length === 0) {
          this.rewardPoolList = new Array(4 + (val <= 3 ? val : 1) * 4)
            .fill(null)
            .map((item) => new Object(this.data))
        } else {
          this.rewardPoolList = JSON.parse(JSON.stringify(this.config))
          if (this.rewardPoolList.length < 4 + (this.docId > 3 ? 1 : this.docId) * 4) {
            let arr = new Array(4 + (this.docId > 3 ? 1 : this.docId) * 4 - this.rewardPoolList.length)
              .fill(null)
              .map((item) => new Object(this.data))
            this.rewardPoolList = this.rewardPoolList.concat(arr)
          }
        }
        this.$forceUpdate()
      },
    },
  },
}
</script>

<style scoped lang="scss">
.drawer-footer {
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  background: #fff;
}
</style>
